const actions = {
    setUserData({ commit, dispatch }, userData) {
        return commit('SET_USER_DATA', userData);
    },
};

export default actions;